import React from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import SynthesisPlannerConditionsChunkComponent from '@Components/Results/synthesis-planner/synthesis-planner-conditions-chunk.component';
import get from 'lodash/get';

import './synthesis-planner-conditions.custom.scss';
import './synthesis-planner-conditions.theme.scss';

const limitToAdditional = 5;

const getDetails = (preparation) => {
  const details = {};

  // eslint-disable-next-line custom/no-unsafe-deep-access
  Object.keys(preparation).forEach((key) => {
    if (key !== 'step') {
      details.condition = preparation[key];
      details.reactionId = key;
    }
  });

  return details;
};

export default class SynthesisPlannerConditionsComponent extends React.Component {
  constructor(props) {
    super(props);

    const {
      data: { limit },
    } = this.props;

    this.state = {
      limit,
    };
  }

  getConditionRows(details) {
    const {
      onFullTextLinkClick,
      onIssueCitedCounterClick,
      onExperimentalProcedureOpen,
      onAbstractOpen,
      onAuthorClick,
      renderCheckboxesColumn,
      handleConditionSelection,
      isConditionCheckedF,
      isConditionVisibleF,
    } = this.props;
    const { limit } = this.state;
    const user = Auth.getUser();
    const {
      data: { resolve },
    } = this.props;
    const databaseId = get(resolve, 'branch.data.databaseId') || get(user, 'details.reaxysId');

    const metadata = {
      databaseId,
      context: 'reactions',
      oldTrackingDisabled: true,
    };

    const slicedToLimit = limit ? details?.condition?.slice(0, limit[details.reactionId]) : details.condition;

    return slicedToLimit.map((chunk, index) => (
      <SynthesisPlannerConditionsChunkComponent
        chunk={chunk}
        details={details}
        metadata={metadata}
        index={index}
        /* eslint-disable-next-line react/no-array-index-key */
        key={index}
        onFullTextLinkClick={onFullTextLinkClick}
        onIssueCitedCounterClick={onIssueCitedCounterClick}
        onExperimentalProcedureOpen={onExperimentalProcedureOpen}
        onAbstractOpen={onAbstractOpen}
        onAuthorClick={onAuthorClick}
        isVisible={isConditionVisibleF(chunk.id)}
        isChecked={isConditionCheckedF(chunk.id)}
        setChecked={handleConditionSelection}
        renderCheckboxesColumn={renderCheckboxesColumn}
      />
    ));
  }

  getConditionSections(preparation, i) {
    const {
      data: { limitTo },
      showSubHeader,
      renderCheckboxesColumn,
    } = this.props;
    const { limit } = this.state;
    const details = getDetails(preparation);

    return (
      <div id={`preparation-${preparation.step} rx-table-container`} key={i}>
        {showSubHeader && <h5>{`Preparation - ${preparation.step}`}</h5>}
        <table className="c-els-table  c-els-table--vertical-dividers c-els-table--subtle-dividers rx-reactions-table rx-table--full-width rx-table--full-height">
          <thead className="c-els-table__head">
            <tr className="c-els-table__row c-els-table__row--head">
              {renderCheckboxesColumn && (
                <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header synthesis-planner-checkbox-th" />
              )}
              <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">Conditions</th>
              <th className="c-els-table__cell c-els-table__basic-cell  c-els-table__cell--header">Yield</th>
              <th className="c-els-table__cell c-els-table__basic-cell  c-els-table__cell--header rx-reactions-table__references u-els-display-none@tablet">
                Reference
              </th>
            </tr>
          </thead>
          <tbody className="c-els-table__body rx-reactions-table--scrollable">{this.getConditionRows(details)}</tbody>
        </table>
        {details?.condition?.length > limitTo && limit && limit[details.reactionId] < details?.condition?.length && (
          <div className="rx-btn-group--center">
            <button
              type="button"
              className="els-btn els-btn-sm els-btn-tertiary e2e-load-more"
              onClick={() => this.loadMore(details.reactionId)}>
              <svg className="els-btn-icon">
                <use xlinkHref="#icon-plus" />
              </svg>
              <span>Load More</span>
            </button>
          </div>
        )}
      </div>
    );
  }

  loadMore(reactionId) {
    this.setState((state) => ({
      limit: {
        ...state.limit,
        [reactionId]: state.limit?.[reactionId] + limitToAdditional,
      },
    }));
  }

  render() {
    const {
      data: { conditions },
    } = this.props;

    return (
      <div className="synthesis-planner-conditions-content__inner">
        {conditions && conditions.map((preparation, i) => this.getConditionSections(preparation, i))}
      </div>
    );
  }
}

SynthesisPlannerConditionsComponent.defaultProps = {
  showSubHeader: true,
  onExperimentalProcedureOpen: () => null,
  onFullTextLinkClick: () => null,
  onIssueCitedCounterClick: () => null,
  onAbstractOpen: () => null,
  onAuthorClick: () => null,
};

SynthesisPlannerConditionsComponent.propTypes = {
  data: PropTypes.object.isRequired,
  showSubHeader: PropTypes.bool,
  onExperimentalProcedureOpen: PropTypes.func,
  onFullTextLinkClick: PropTypes.func,
  onIssueCitedCounterClick: PropTypes.func,
  onAbstractOpen: PropTypes.func,
  onAuthorClick: PropTypes.func,
  handleConditionSelection: PropTypes.func,
  isConditionVisibleF: PropTypes.func,
  isConditionCheckedF: PropTypes.func,
  renderCheckboxesColumn: PropTypes.bool,
};
